export default __webpack_public_path__ + "static/media/card-no-text.cd68658b.svg";